import { render, staticRenderFns } from "./AddLinkedAccountUser.vue?vue&type=template&id=00f86fbc&scoped=true"
import script from "./AddLinkedAccountUser.vue?vue&type=script&lang=js"
export * from "./AddLinkedAccountUser.vue?vue&type=script&lang=js"
import style0 from "./AddLinkedAccountUser.vue?vue&type=style&index=0&id=00f86fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f86fbc",
  null
  
)

export default component.exports